<template>
  <div>
    <div class="layout-login login-form">
      <div class="login-title">
        ログイン
      </div>
      <form-block>
        <b-form-group label="ユーザー名" class="plain"
                      :invalid-feedback="validation.firstError('form.username')"
                      :state="validation.hasError('form.username') ? 'invalid' : null">
          <b-form-input :state="validation.hasError('form.username') ? 'invalid' : null"
                        v-model.lazy="form.username"/>
        </b-form-group>
        <b-form-group label="パスワード" class="plain"
                      :invalid-feedback="validation.firstError('form.password')"
                      :state="validation.hasError('form.password') ? 'invalid' : null">
          <b-form-input :state="validation.hasError('form.password') ? 'invalid' : null"
                        v-model.trim="form.password" type="password"></b-form-input>
        </b-form-group>
        <b-button class="login-button" size="lg" block variant="primary" :disabled="working" @click="login()">ログイン</b-button>
      </form-block>
    </div>
    <div class="layout-login-footer">Copyright (c) 2018-2019 LinkJapan All Rights Reserved.</div>
  </div>
</template>

<script type="text/babel">
  'use strict';

  import FormBlock from '../../vue-components/common/bootstrapvue-console/FormBlock.vue';

  import {Validator} from 'simple-vue-validator';

  export default {
    components: {
      FormBlock
    },
    data() {
      return {
        form: {
          username: '',
          password: ''
        },
        working: false
      };
    },
    validators: {
      'form.username'(value) {
        return Validator.value(value).required('必須');
      },
      'form.password'(value) {
        return Validator.value(value).required('必須');
      }
    },
    methods: {
      async login() {
        let result = await this.$validate();
        if (!result) {
          return;
        }
        this.working = true;
        try {
          await this.$http.post('/api/login', this.form);
          window.location.href = '/console';
        } catch (e) {
          if (e.status === 400) {
            this.$utils.toast.warning('ユーザー名またはパスワードのエラー。');
          } else {
            this.$utils.handleGeneralError(e);
          }
        } finally {
          this.form.password = '';
          this.validation.reset();
          this.working = false;
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// client/app/vue-components/login/App.vue